module.exports = __webpack_public_path__ + "static/media/gsd8.2072f346.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/es/gsd8.png
// module id = 139
// module chunks = 0